<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Controls</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (controlVoltageSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Voltage:</label>
            <select class="halfWidthInputField" #controlVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlVoltageSelection.Name)"
              (change)="selectionChanged(controlVoltageSelection, controlVoltageInput.value)"
              [value]="controlVoltageSelection.Value.toString()">
              @for (allowable of controlVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlVoltageSelection.Value && controlVoltageSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (controlTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Type:</label>
            <select class="halfWidthInputField" #controlTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlTypeSelection.Name)"
              (change)="selectionChanged(controlTypeSelection, controlTypeInput.value)"
              [value]="controlTypeSelection.Value.toString()">
              @for (allowable of controlTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlTypeSelection.Value && controlTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (thermostatTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Thermostat Type:</label>
            <select class="halfWidthInputField" #thermostatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(thermostatTypeSelection.Name)"
              (change)="selectionChanged(thermostatTypeSelection, thermostatInput.value)"
              [value]="thermostatTypeSelection.Value.toString()">
              @for (allowable of thermostatTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="thermostatTypeSelection.Value && thermostatTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (skyportServiceSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(skyportServiceSelection.Name)"
              for="skyportServiceInput" class="halfWidthInputLabel">
              IEC Skyport Setup Service<br/>(Wi-Fi Thermostat):
            </label>
            <input type="checkbox" class="checkboxInput" id="skyportServiceInput"
              #skyportServiceInput [checked]="'true' === skyportServiceSelection.Value"
              (change)="selectionChanged(skyportServiceSelection, skyportServiceInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (condensateSwitchSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(condensateSwitchSelection.Name)"
            for="condensateSwitchInput" class="halfWidthInputLabel">Condensate Switch:</label>
            <input type="checkbox" class="checkboxInput" id="condensateSwitchInput"
              #condensateSwitchInput [checked]="'true' === condensateSwitchSelection.Value"
              (change)="selectionChanged(condensateSwitchSelection, condensateSwitchInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (serviceLightSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(serviceLightSelection.Name)"
            for="serviceLightInput" class="halfWidthInputLabel">LED Service Light:</label>
            <input type="checkbox" class="checkboxInput" id="serviceLightInput"
              #serviceLightInput [checked]="'true' === serviceLightSelection.Value"
              (change)="selectionChanged(serviceLightSelection, serviceLightInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
